import {useLanguage} from '@/contexts/LanguageContext'

function StatsSection() {
  const {t} = useLanguage()

  return (
    <section className="relative z-10 px-6 py-20">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-14 text-white">{t.stats.title}</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-12">
          {t.stats.items.map(stat => (
            <div
              key={stat.label}
              className="rounded-xl border border-white/10 bg-slate-900/60 p-6 text-center transition-all duration-300 hover:-translate-y-0.5 hover:border-indigo-400/50 hover:bg-indigo-500/5 hover:shadow-[0_0_35px_rgba(99,102,241,0.35)]"
            >
              <div className="text-3xl md:text-4xl font-bold mb-1 bg-gradient-to-r from-indigo-400 to-sky-400 bg-clip-text text-transparent">
                {stat.value}
              </div>
              <div className="text-gray-400 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
        <div className="rounded-xl border border-white/10 bg-slate-900/60 p-8 text-center">
          <p className="text-base md:text-lg text-gray-400 leading-relaxed">
            {t.stats.bottomBefore}
            <span className="text-indigo-300 font-semibold">{t.stats.bottomHighlight}</span>
            {t.stats.bottomAfter}
          </p>
        </div>
      </div>
    </section>
  )
}

export default StatsSection
